

const MESSAGES_SET_MESSAGE = (state, payload) => {   
    state.data.message=payload
};

const MESSAGES_SET_STATUS = (state, payload) => {   
    state.data.statuscode=payload
};

const MESSAGES_SET_SHOW = (state, payload) => {   
    state.data.showmessage=payload
    if(!state.data.showmessage) {
        state.data.message=""
        state.data.statuscode=undefined
    }
};


const MESSAGES_INIT_MESSAGE  = (state, payload) => {   
    
    state.data.message="",
    state.data.statuscode=undefined,
    state.data.showmessage=false

};
const MESSAGES_SET_DATA  = (state, payload) => {   
    
    state.data.message=payload.message,
    state.data.statuscode=payload.statuscode,
    state.data.showmessage=payload.showmessage       
};

export default {  
  MESSAGES_SET_MESSAGE,
  MESSAGES_SET_STATUS,
  MESSAGES_SET_SHOW,  
  MESSAGES_INIT_MESSAGE,
  MESSAGES_SET_DATA
 
};